import app from '../app';

/**
 * Сервис для функционала "Закрытая База"
 */
app.service('hiddenBaseService', [
  'addFormService',
  'categoryService',
  '$rootScope',
  function (addFormService, categoryService, $rootScope) {
    /**
     * Может ли пользователь размещать в Закрытую Базу
     * На форме подачи название переключателя "Видимость"
     * Значение содержится в ответе API user
     * Так же есть в объекте window.addFormState(не используем)
     * @type {Boolean}
     */
    this.canUseHiddenBase = false;
    $rootScope.$on('user.setUser', (e, user) => {
      this.canUseHiddenBase = user.canUseHiddenBase;
    });

    this.isCurrentCategoryAllowed = false;
    $rootScope.$watch(
      () => addFormService.ad && addFormService.ad.category,
      category => {
        const categoryInfo = categoryService.getInfoByCategory(category);
        /**
         * Размещение в закрытую базу по категории доступно только для всех категорий кроме Квартиры в новостройке
         * @type {Boolean}
         */
        this.isCurrentCategoryAllowed =
          categoryInfo.dealType && categoryInfo.propertyType && categoryInfo.objectType !== 'newBuildingFlat';

        /**
         * Сборс значения isInHiddenBase
         * Если была смена категории и новая категория недоступна для размещения в закрытую базу
         */
        if (!this.isCurrentCategoryAllowed && addFormService.ad) {
          addFormService.ad.isInHiddenBase = undefined;
        }
      },
    );

    this.isAvailable = () => this.canUseHiddenBase && this.isCurrentCategoryAllowed;

    this.isEnabled = () => this.isAvailable() && addFormService.ad.isInHiddenBase;

    this.onChangeSwitcherHiddenBase = () => {
      if (this.isEnabled()) {
        addFormService.ad.publishTerms = undefined;
      }
    };
  },
]);
